import { createFileRoute } from "@tanstack/react-router";

import { AdminPaymentMethodsTab } from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/accounts/$projectId/payment-methods",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return <AdminPaymentMethodsTab projectId={Number(projectId)} />;
}
